import { Popconfirm } from 'antd'
import PropTypes from 'prop-types'

const PopconfirmCommon = ({
	children,
	title,
	onConfirm,
	onCancel,
	okText = 'Yes',
	cancelText = 'No',
	placement = 'Top',
	visible,
	okButtonProps,
}) => {
	const handleConfirm = e => {
		onConfirm && onConfirm(e)
	}

	const handleCancel = e => {
		onCancel && onCancel(e)
	}

	return (
		<Popconfirm
			visible={visible}
			title={title}
			onConfirm={handleConfirm}
			onCancel={handleCancel}
			okText={okText}
			cancelText={cancelText}
			placement={placement}
			okButtonProps={okButtonProps}
		>
			{children}
		</Popconfirm>
	)
}

PopconfirmCommon.propTypes = {
	children: PropTypes.any,
	title: PropTypes.any,
	onConfirm: PropTypes.func,
	onCancel: PropTypes.func,
	okText: PropTypes.string,
	cancelText: PropTypes.string,
	placement: PropTypes.string,
	visible: PropTypes.any,
	okButtonProps: PropTypes.any,
}

export default PopconfirmCommon
